import React, { Component } from 'react';
import { Table, Button, message, Popconfirm } from 'antd';
import UpdateResearcher from './UpdateResearcher';
import { ResearcherDetail as UpdateDetail } from './UpdateDetail';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import moment from 'moment';

class Researcher extends Component {
    state = {
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
        data: [],
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { hospitalDepartmentId } = this.props;
        const { pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryReviewResearcher,
            data: {
                offset: current,
                limit: 10,
                hospitalDepartmentId,
            },
            dataType: 'json',
            doneResult: res => {
                const { totalCount = 0, datas = [] } = res;
                let childrenLength = 0;
                datas.forEach(item =>{
                    childrenLength = childrenLength + (item.reviewResearcherRecords ? item.reviewResearcherRecords.length : 1);
                })
                pagination.total = totalCount;
                this.setState({
                    pagination:{...pagination,pageSize:childrenLength,total: Math.ceil((totalCount/10))*childrenLength},
                    data: datas,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getRender = (num) => {
        return (text, record) => {
            const obj = {
                children: text,
                props: {},
            };
            const { rowSpan } = record;
            obj.props.rowSpan = num ? num : rowSpan;
            return obj;
        };
    }

    delete = record => {
        const { reviewResearcherId } = record;
        const options = {
            method: 'POST',
            url: API_URL.hospital.deleteReviewResearcher,
            data: { reviewResearcherId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { isAdd } = this.props;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
            render: this.getRender(),
        }, {
            title: '研究者姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 80,
            render: this.getRender(),
        }, {
            title: '擅长适应症',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            render: this.getRender(1),
            width: 120,
        }, {
            title: '擅长适应症的月门诊量',
            dataIndex: 'outPatientNum',
            key: 'outPatientNum',
            width: 80,
            render: this.getRender(1),
        }, {
            title: '该研究者的临床试验项目经验',
            dataIndex: 'clinicalExperienceShow',
            key: 'clinicalExperienceShow',
            width: 105,
            render: this.getRender(),
        }, {
            title: '该研究者的GCP意识',
            dataIndex: 'gcpShow',
            key: 'gcpShow',
            width: 80,
            render: this.getRender(),
        }, {
            title: '该研究者的配合度',
            dataIndex: 'coordinationShow',
            key: 'coordinationShow',
            width: 115,
            render: this.getRender(),
        }, {
            title: '该研究者的CFDA视察经验',
            dataIndex: 'cfdaShow',
            key: 'cfdaShow',
            width: 90,
            render: this.getRender(),
        }, {
            title: '该研究者在研究中角色',
            dataIndex: 'investigationRoleShow',
            key: 'investigationRoleShow',
            width: 80,
            render: (text, record) => {
                const obj = {
                    children: null,
                    props: {},
                };
                const { rowSpan, identityMap } = record;
                obj.props.rowSpan = rowSpan;
                const entries = Object.entries(identityMap || {});
                obj.children = (
                    entries.map((item, index) => {
                        return <span key={index} style={{ color: item[1] ? '#ccc' : '#000000a6'}}>{item[0]}{index < entries.length - 1 && '，'}</span>
                    })
                );
                return obj;
            }
        }, {
            title: '津石合作紧密程度',
            dataIndex: 'cooperationDegreeShow',
            key: 'cooperationDegreeShow',
            width: 80,
            render: this.getRender(),
        }, {
            title: '该研究者推荐指数',
            dataIndex: 'recommendRateShow',
            key: 'recommendRateShow',
            width: 80,
            render: this.getRender(),
        }, {
            title: '该研究者生日',
            dataIndex: 'birthday',
            key: 'birthday',
            width: 90,
            render: (text, record) => {
                const obj = {
                    children: null,
                    props: {},
                };
                const { rowSpan } = record;
                obj.props.rowSpan = rowSpan;
                obj.children = text ? moment(text).format('MM-DD') : '';
                return obj;
            }
        }, {
            title: '该研究者英文',
            dataIndex: 'englishLevelShow',
            key: 'englishLevelShow',
            width: 90,
            render: this.getRender(),
        }, {
            title: '该研究者子女',
            dataIndex: 'sonCount',
            key: 'sonCount',
            width: 90,
            render: (text, record) => {
                const obj = {
                    children: null,
                    props: {},
                };
                const { rowSpan } = record;
                const { sonCount, dauCount } = record;
                obj.props.rowSpan = rowSpan;
                let res = '';
                if(sonCount == null && dauCount == null){
                    res = '';
                } else if(sonCount != null && dauCount == null){
                    res = `${sonCount}子`;
                } else if(sonCount == null && dauCount != null){
                    res = `${dauCount}女`;
                } else{
                    res = `${sonCount}子${dauCount}女`;
                }
                obj.children =res;
                return obj;
            }
        }, {
            title: '该研究者兴趣爱好和特别注意事项',
            dataIndex: 'hobbiesAndSpecialConsiderations',
            key: 'hobbiesAndSpecialConsiderations',
            width: 160,
            render: this.getRender(),
        }, {
            title: '该研究者备注',
            dataIndex: 'remark',
            key: 'remark',
            render: this.getRender(),
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            fixed: 'right',
            width: isAdd ? 140 : 90,
            render: (text, record) => {
                const obj = {
                    children: null,
                    props: {},
                };
                const { rowSpan } = record;
                obj.props.rowSpan = rowSpan;
                obj.children = (
                    <span>
                        {
                            isAdd &&
                            <span>
                                <a onClick={() => this.update(record)}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title='确定要删除吗?' onConfirm={() => this.delete(record)} okText="确定" cancelText="取消">
                                    <a>删除</a>
                                </Popconfirm>
                                <span className="ant-divider" />
                            </span>
                        }
                        <a onClick={() => this.showDetail(record)}>更新日志</a>
                    </span>
                );
                return obj;
            }
        }];
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;

        let key = 0;
        const dataSource = [];
        data.forEach((item, index) => {
            const { reviewResearcherRecords = [] } = item;
            if (reviewResearcherRecords && reviewResearcherRecords.length) {
                reviewResearcherRecords.forEach((innerItem, innerIndex) => {
                    const { diseaseName, diseaseRemark, outPatientNum } = innerItem;
                    dataSource.push({
                        ...item,
                        key: key++,
                        outPatientNum,
                        index: index + 1,
                        rowSpan: innerIndex === 0 ? reviewResearcherRecords.length : 0,
                        diseaseName: diseaseName ? `${diseaseName}${diseaseRemark ? `(${diseaseRemark})` : ''}` : '',
                    });
                });
            } else {
                dataSource.push({
                    ...item,
                    key: key++,
                    outPatientNum: '',
                    index: index + 1,
                    rowSpan: 1,
                    diseaseName: '',
                });
            }
        });
        return dataSource;
    }
    
    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams = {} } = this.state;
        sortParams.sort = sorter.field;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    update = record => {
        this.updateRef.show(record);
    }

    showDetail = record => {
        this.detailRef.show(record);
    }

    render() {
        const { isAdd, hospitalDepartmentId } = this.props;
        const { loading, pagination } = this.state;
        return (
            <div>
                {
                    isAdd &&
                    <div style={{ marginBottom: 12, textAlign: 'right' }}>
                        <Button type="primary" onClick={() => this.update()}>添加研究者点评</Button>
                    </div>
                }
                <Table
                    bordered
                    loading={loading}
                    scroll={{ x: 1700 }}
                    rowKey={row => row.key}
                    pagination={pagination}
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    onChange={this.handleTableChange}
                />
                <UpdateResearcher ref={el => this.updateRef = el} loadData={this.loadData} hospitalDepartmentId={hospitalDepartmentId} />
                <UpdateDetail ref={el => this.detailRef = el} loadData={this.loadData} />
            </div>
        )
    }
}

export default Researcher;


// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/Researcher.js